import Translator from 'tools/trans';
import { setReleaseHeaderImage } from 'press/setReleaseHeaderImage';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const enhancedTable = $('#pressNews').dataTable({
    'bPaginate': true,
    'ordering': true,
    'order': [],
    'paging': true,
    'pagingType': 'simple',
    'aaSorting': [],
    'bSort': true, //set to true if you want the table to be sortable
    'bAutoWidth': false,
    'iDisplayLength': 20,
    'aLengthMenu': [[25, 50, 100, -1], [25, 50, 100, Translator.trans('FORM_SEARCH_ALL')]],
    'bLengthChange': false, // hide dropdownlist number
    'oLanguage': { // Language Settings
        'sSearch': '',
        'oPaginate': {
            'sNext': Translator.trans('PRESS_TABLE_NEXT'),
            'sPrevious': Translator.trans('PRESS_TABLE_PREVIOUS'),
        },
        'sInfo': '',
        'sInfoEmpty': '',
        'sZeroRecords': Translator.trans('STATISTIC_TABLE_ZERO_ENTRIES'),
        'sEmptyTable': Translator.trans('STATISTIC_TABLE_EMPTY'),
        'sInfoFiltered': '',
    },
    'fnDrawCallback': oSettings => {
        const paginateButtons = document.querySelectorAll('.dataTables_paginate > .paginate_button');
        const tableWrapperPaginators = oSettings.nTableWrapper.querySelectorAll('.dataTables_paginate');
        paginateButtons.forEach(paginateButton => {
            paginateButton.classList.add('button');
            paginateButton.classList.add('margin-left-15');
        });
        if (oSettings._iDisplayLength >= oSettings.fnRecordsDisplay() || oSettings._iDisplayLength < 0) {
            tableWrapperPaginators.forEach(tableWrapperPaginator => {
                tableWrapperPaginator.classList.add('hidden');
            });
        } else {
            tableWrapperPaginators.forEach(tableWrapperPaginator => {
                tableWrapperPaginator.classList.remove('hidden');
            });
        }
    },
});

setReleaseHeaderImage();
